import React from 'react';

const PricingToggle = ({ billingCycle, onToggle }) => {
  return (
    <div className="flex items-center justify-center gap-3 md:gap-4">
      <span className={`font-body text-sm md:text-base font-medium transition-smooth ${billingCycle === 'monthly' ? 'text-foreground' : 'text-muted-foreground'}`}>
        Monthly
      </span>
      <button
        onClick={onToggle}
        className="relative h-8 w-14 md:h-10 md:w-16 rounded-full bg-muted transition-smooth hover:bg-muted/80 focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
        aria-label="Toggle billing cycle"
      >
        <span
          className={`absolute top-1 h-6 w-6 md:h-8 md:w-8 rounded-full bg-primary shadow-purple transition-smooth ${
            billingCycle === 'yearly' ? 'left-7 md:left-7' : 'left-1'
          }`}
        />
      </button>
      <span className={`font-body text-sm md:text-base font-medium transition-smooth ${billingCycle === 'yearly' ? 'text-foreground' : 'text-muted-foreground'}`}>
        Yearly
        <span className="ml-2 inline-block rounded-full bg-success/10 px-2 py-0.5 text-xs font-medium text-success">
          Save 20%
        </span>
      </span>
    </div>
  );
};

export default PricingToggle;